import Api from '@api/xiao_xiong/appeal'
import { action, observable, runInAction, toJS } from 'mobx'
import { message } from 'hljd'
import { getObjValue } from '@hlj/hlj-utils'
import { APPRAISE_LIST_PATH_A } from '@constant'

class Store {
  id //申诉页面的评价/回复id
  type //申诉页面的类型 评价/回复
  entity_id //回复时用于提交成功后页面跳转 type = 2
  kind //增加的问答 kind == 'question' 时为问答
  setId = (id, type, kind) => {
    this.id = id
    this.type = type
    this.kind = kind
  }
  @action
  getAppealInfo = async () => {
    const { data, success } = await Api.getContentApi({
      id: this.id,
      type: this.type
    })
    if (success) {
      if (this.type == 1) {
        //评价
        runInAction(() => {
          this.author = data.author
          this.comment_photos = data.comment_photos
          this.comment_video = data.comment_video
          this.created_at = data.created_at
          this.rating = data.rating
          this.content_appeal = data.content
          this.ratingText =
            data.rating == 1
              ? '不好'
              : data.rating == 2
                ? '一般'
                : data.rating == 3
                  ? '基本满意'
                  : data.rating == 4
                    ? '很满意'
                    : data.rating == 5
                      ? '超出预期'
                      : ''
        })
      } else if (this.type == 2) {
        //回复
        runInAction(() => {
          this.author = data.user
          this.comment_photos = []
          this.created_at = data.created_at
          this.rating = data.rating
          this.content_appeal = data.content
          this.ratingText = ''
          this.entity_id = data.entity_id
        })
      }
    }
  }

  //问答获取详情
  question_id = '' //只在是申诉回答时用到 type = 2 且 kind == 'question'
  @observable content_question = ''
  @observable created_at_question = ''
  @observable nick_question = ''
  @action
  getAppealInfo_question = async () => {
    const { data = {}, success } = await Api.getAppealInfo_questionApi({
      entity_id: this.id,
      type: this.type
    })
    if (success) {
      runInAction(() => {
        this.content_question =
          this.type == '2' ? data.content || '' : data.title || ''
        this.created_at_question = data.created_at || ''
        this.nick_question = getObjValue(data, 'user.nick')
        this.question_id = data.question_id || ''
      })
    }
  }

  /**
   * 申诉理由
   */
  @observable reason = ''
  @observable content = ''

  @action
  changeReason = e => {
    this.reason = e.target.value
  }
  @action
  changeContent = value => {
    this.content = value
  }

  /**
   * 上传图片
   */
  @observable photos = []
  @observable showUpload = true

  @action
  uploadOk = (link, info) => {
    this.photos.push({
      image_path: link,
      height: info.height,
      width: info.width
    })
    this.showUpload = !(this.photos.length >= 9)
  }
  @action
  removeImg = index => {
    this.photos = this.photos.filter((item, i) => index !== i)
  }

  /**
   * type =1、2 评价/回复内容字段，
   */
  @observable author = {}
  @observable comment_photos = [] //2时置空
  @observable comment_video = null
  @observable created_at = ''
  @observable rating = '' //2时置空
  @observable content_appeal = ''
  @observable ratingText = '' //2时置空

  /**
   * 初始化
   */
  @action
  init = () => {
    //id 、type 已经在外层组件重置，这里不进行重置
    this.photos = []
    this.content = ''
    this.reason = ''
    this.entity_id = ''
  }

  /**
   * 提交申诉
   */
  @observable isModalShow = false //控制tipModal显示
  @action
  submitAppeal = async () => {
    let params = this.getParams()
    if (this.kind == 'question') {
      const { success } = await Api.submitAppeal_questionApi(params)
      if (success) {
        this.isModalShow = true
        //message.success('申诉已经提交成功~',1)
        let backId = this.type == '1' ? this.id : this.question_id // 问题时取id即可，回答时取question_id
        setTimeout(() => {
          this.isModalShow = false
          window.location.href = `${APPRAISE_LIST_PATH_A}/questionAndAnswer/${backId}`
        }, 1000)
      }
    } else {
      const { content, photos } = params
      if (!content || content.length < 30 || content.length > 200) {
        message.error('申诉需要填写30-200字文字描述')
        return
      }

      if (!photos || photos.length < 1 || photos > 9) {
        message.error('举证图片必须上传，需上传1-9张图片')
        return
      }
      const { success } = await Api.submitAppealApi(params)
      if (success) {
        message.success('申诉已经提交成功~', 1)
        let backId = this.type == 2 ? this.entity_id : this.id
        setTimeout(() => {
          window.location.href = `${APPRAISE_LIST_PATH_A}/${backId}`
        }, 1000)
      }
    }
  }
  getParams = () => {
    let { content, photos, reason, type, id, kind } = this
    if (kind == 'question') {
      //问答
      let reasonNum
      switch (reason) {
        case '恶意诋毁':
          reasonNum = 1
          break
        case '广告':
          reasonNum = 2
          break
        case '色情':
          reasonNum = 3
          break
        case '辱骂脏话':
          reasonNum = 4
          break
        case '其他':
          reasonNum = 5
          break
      }
      return {
        content,
        photos: toJS(photos),
        reason: reasonNum,
        type,
        entity_id: id,
        merchant_id: JSON.parse(sessionStorage.getItem('merchant_info')).id
      }
    } else {
      let idType = type == 1 ? 'order_comment_id' : 'community_comment_id'
      return {
        content,
        photos: toJS(photos),
        reason,
        type,
        [idType]: id
      }
    }
  }

  @observable preViewPath = ''
  @action
  showPreviewModal = path => () => {
    this.preViewPath = path
  }

  // 是否显示
  @observable initialPrew = 0
  @observable prew = false
  @observable imglist = []
  @action
  prewImg = (initialPrew, imgarr) => () => {
    this.prew = !this.prew
    this.initialPrew = initialPrew
    this.imglist = imgarr
  }
}
export default new Store()
